// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// *************************************************************** smsPacks assignment *****************************************************************

const SHOW_ONEASSIGNMENT_SUCCESS = "SHOW_ONEASSIGNMENT_SUCCESS";
const STORE_SMSASSIGNMENT_SUCCESS = "STORE_SMSASSIGNMENT_SUCCESS";
const STORE_RULE_PACK_RULE_SUCCESS = "STORE_RULE_PACK_RULE_SUCCESS";
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _showSuccessCustom(payload) {
  return {
    type: SHOW_ONEASSIGNMENT_SUCCESS,
    payload: payload.data,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _AddPositionsSuccess(payload) {
  return {
    type: STORE_SMSASSIGNMENT_SUCCESS,
    payload: payload.data,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSmsPackRuleSuccess(payload) {
  return {
    type: STORE_RULE_PACK_RULE_SUCCESS,
    payload: payload.data,
  };
}
// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function AddPositions(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate("در حال انجام عملیات"));

    api
      .post("/SmsPatterns/AddPositionsToPattern", { data })
      .then((r) => {
        dispatch(_AddPositionsSuccess(r));
        loader.hide(() =>
          app.message(app.translate("عملیات با موفقیت انجام شد"))
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.rule-pack",
            "SmsPack",
            app.translate("عملیات شکست خورد!")
          )
        );
      });
  };
}
/**
 *
 * @param {Number} smsPack
 * @param {Object} params
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function shows(smsPack, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/SmsPatterns/GetAssignedPositions?id=${smsPack}`)
      .then((r) => {
        dispatch(_showSuccessCustom(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function storeSmsPackRule(data, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate("در حال انجام عملیات"));

    api
      .post("/SmsPatterns/AddPositionsToPattern", { data })
      .then((r) => {
        dispatch(_storeSmsPackRuleSuccess(r));
        loader.hide(() =>
          app.message(app.translate("عملیات با موفقیت انجام شد"))
        );
        callback(r);
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.rule-pack",
            "SmsPack",
            app.translate("عملیات شکست خورد!")
          )
        );
      });
  };
}
/**
 *
 * @return {Function}
 */
export function emptySmsPack() {
  return _showSuccessCustom({ data: { Assignment: [] }, meta: {} });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    Assignment: "",
    meta: {},
    smsPack: {},
  },
  action
) {
  let smsPack;

  switch (action.type) {
    case SHOW_ONEASSIGNMENT_SUCCESS:
      return Object.assign({}, state, {
        Assignment: action?.payload,
        meta: action?.payload,
      });
    case STORE_SMSASSIGNMENT_SUCCESS:
      smsPack = app._.cloneDeep(state.smsPack);
      let _rules = [];
      _rules.push(action.payload);
      if (!app._.isEmpty(smsPack.rules)) {
        _rules.push(...smsPack.rules);
      }
      smsPack.rules = _rules;
      return Object.assign({}, state, {
        SmsPackRule: action.payload,
        smsPack,
      });
    default:
      return state;
  }
}
